import script from "./Layout6.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout6.vue?vue&type=script&lang=ts&setup=true"

import "./Layout6.vue?vue&type=style&index=0&id=96634b44&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96634b44"]])

export default __exports__